import { convertAttributeToArray, convertAttributeToBoolean } from './attribute-utils.js';
import { debounce } from './render-utils.js';
import { setPropertyByPath } from './ref-utils.js';

export class HTMLCustomElement extends HTMLElement {
  static isTestMode = false;
  refs = {};
  test = { refs: {} };

  constructor(params) {
    const element = super(params);
    const renderFn = element.render || element._render || (() => {});

    element.requestRender = debounce((...args) => {
      renderFn.call(this, ...args);
    }, this);

    element.init();

    return element;
  }

  init() {}

  childrenChangedCallback() {}

  attributeChangedCallback(name, oldValue, newValue) {
    const transformedName = name.replace(/-([a-z])/g, g => g[1].toUpperCase());
    this[transformedName] = newValue;
  }

  watchForAddedChildNodes(options) {
    if (!window.MutationObserver) {
      return;
    }

    const defaultOptions = { childList: true, subtree: false };
    options = Object.assign(defaultOptions, options);

    const observer = new window.MutationObserver(mutations => {
      const nodes = mutations.map(mutationRecord => mutationRecord.addedNodes);
      this.childrenChangedCallback(nodes);
    });

    observer.observe(this, options);
  }

  reflectStringAttribute(name, value) {
    if (value === null && this.hasAttribute(name)) {
      this.removeAttribute(name);
    } else if (this.getAttribute(name) !== value) {
      this.setAttribute(name, value);
    }
  }

  reflectBooleanAttribute(name, value) {
    const attributeValue = convertAttributeToBoolean(value);

    if (attributeValue === false && this.hasAttribute(name)) {
      this.removeAttribute(name);
    } else if (attributeValue === true && !this.hasAttribute(name)) {
      this.setAttribute(name, '');
    }
  }

  createReference(path, options = { testOnly: false }) {
    const targets = [
      ...(!options.testOnly ? [this.refs] : []),
      ...(HTMLCustomElement.isTestMode ? [this.test.refs] : [])
    ];
    return (node) => targets.forEach((target) => setPropertyByPath(target, path, node));
  }

  _convertAttributeToBoolean(value) {
    return convertAttributeToBoolean(value);
  }

  _convertAttributeToArray(value) {
    return convertAttributeToArray(value);
  }

  _cleanupContainer(containerSelector) {
    const container = this.querySelector(containerSelector);
    if (container) {
      this.removeChild(container);
    }
  }
}
